import * as Sentry from '@sentry/react'

import { ENVIRONMENT, SENTRY_DSN } from './runtime'

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // The commit, not just the package version: every snapshot between two
  // releases is built from main and would otherwise report the same release.
  release: `${__APP_VERSION__}+${__APP_COMMIT__}`,
  environment: ENVIRONMENT,
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.1,
})
